import classNames from "classnames";
import { useCollapsedState } from "components/DetailPage/hooks";
import React, { useState } from "react";
import SupportQuestionMark from "supportbeacon/SupportQuestionMark";

interface Props {
  className?: string
  innerContentClassName?: string
  id?: string
  collapsible?: {
    start: "open" | "closed"
    uniqueRowId: string
    persist: boolean
  }

  header?: React.ReactNode
  supportArticleId?: number
  button?: React.ReactNode
  panelRef?: React.RefObject<HTMLDivElement> | React.LegacyRef<HTMLDivElement>
}

const BasePanel = (props: React.PropsWithChildren<Props>) => {
  const { collapsed, toggleCollapsed } = useCollapsedState(props.collapsible?.uniqueRowId, props.collapsible?.start === "closed", props.collapsible?.persist);
  const [closingSection, setClosingSection] = useState(false);
  const [openingSection, setOpeningSection] = useState(false);

  const onToggle = () => {
    if (collapsed) {
      open();
    } else {
      close();
    }
  };

  const onHeaderClick: React.MouseEventHandler<HTMLElement> = (e) => {
    e.persist();
    const target = e.target as HTMLElement;

    if (target.closest("button") || target.closest("a")) {
      return;
    }

    onToggle();
  }

  const open = () => {
    if (closingSection || openingSection) {
      return;
    }

    setOpeningSection(true);
    setTimeout(() => {
      setOpeningSection(false);
      toggleCollapsed();
    }, 300);
  };

  const close = () => {
    if (closingSection || openingSection) {
      return;
    }

    setClosingSection(true);
    setTimeout(() => {
      setClosingSection(false);
      toggleCollapsed();
    }, 300);
  };
  const isCollapsible = props.collapsible != null;
  const shouldRenderHeader = props.header != null || props.collapsible != null;

  const classes = classNames("s1_panel",
    {
      "collapsible-panel": isCollapsible,
      collapsed: isCollapsible && collapsed && !closingSection && !openingSection,
      open: isCollapsible && !collapsed && !openingSection && !closingSection,
      opening: isCollapsible && openingSection,
      collapsing: isCollapsible && closingSection
    },
    props.className);

  return <div id={props.id} className={classes} ref={props.panelRef}>
    {shouldRenderHeader && <div onClick={isCollapsible ? onHeaderClick : undefined} className={classNames("section-panel-header", { clickable: isCollapsible })}>
      {props.header}

      {props.supportArticleId && <SupportQuestionMark articleId={props.supportArticleId} />}
      {isCollapsible && <div>
        <a onClick={isCollapsible ? onToggle : undefined} className="collapsible-panel-icon icon-angle-down big"></a>
      </div>}
      {props.button && <div>
        {props.button}
      </div>}
    </div>}

    <div className="collapsible-panel-content">
      <div className={classNames(props.innerContentClassName, "collapsible-panel-content-inner", {
        open: !collapsed && !closingSection && !openingSection
      })}>
        {props.children}
      </div>
    </div>
  </div>
}


export default BasePanel;